import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.409 14h-6.01c-.55 0-1 .45-1 1s.45 1 1 1h6.01v1.79c0 .45.54.67.85.35l2.78-2.79c.19-.2.19-.51 0-.71l-2.78-2.79c-.31-.32-.85-.09-.85.35V14zm5.98-2.21V10h6.01c.55 0 1-.45 1-1s-.45-1-1-1h-6.01V6.21c0-.45-.54-.67-.85-.35l-2.78 2.79c-.19.2-.19.51 0 .71l2.78 2.79a.5.5 0 00.85-.36z" fill="#444" /></svg>;